import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiLibraryIconComponent } from '../ui-library-icon/ui-library-icon.component';
import { UiCategoryTone } from '../../types/ui-category-tone.type';
import { UiLibraryIconName } from '../../types/ui-library-icon-name.type';

@Component({
  selector: 'ui-category-tile',
  imports: [UiLibraryIconComponent],
  templateUrl: './ui-category-tile.component.html',
  styleUrl: './ui-category-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCategoryTileComponent {
  public readonly name: InputSignal<string> = input.required<string>();
  public readonly count: InputSignal<number | null> = input<number | null>(null);
  public readonly hint: InputSignal<string | null> = input<string | null>(null);
  public readonly iconLabel: InputSignal<string> = input.required<string>();
  public readonly iconName: InputSignal<UiLibraryIconName | null> = input<UiLibraryIconName | null>(null);
  public readonly tone: InputSignal<UiCategoryTone> = input<UiCategoryTone>('amber');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly selected: OutputEmitterRef<void> = output<void>();

  protected readonly hasHint: Signal<boolean> = computed((): boolean => !!this.hint());
  protected readonly isAmber: Signal<boolean> = computed((): boolean => this.tone() === 'amber');
  protected readonly isBlue: Signal<boolean> = computed((): boolean => this.tone() === 'blue');
  protected readonly isGreen: Signal<boolean> = computed((): boolean => this.tone() === 'green');
  protected readonly isPink: Signal<boolean> = computed((): boolean => this.tone() === 'pink');
  protected readonly isViolet: Signal<boolean> = computed((): boolean => this.tone() === 'violet');
  protected readonly isTeal: Signal<boolean> = computed((): boolean => this.tone() === 'teal');

  protected handleSelected(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.selected.emit();
  }
}
